import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from '../permission-access-service/permissionBased.service';
import { SharedDataService } from '../shared-service/shared-data.service';
import { map, take } from 'rxjs';

export const PermissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const permissionService = inject(PermissionService);
  const sharedDataService = inject(SharedDataService);
  const router = inject(Router);
 
  const requiredPermissions: string[] = route.data?.['permissions'] || [];
  return sharedDataService.getUser().pipe(
    take(1),
    map(user => {
      if (!user) {
        router.navigate(['/login']);
        return false;
      }

      if (requiredPermissions.length === 0) {
        return true;
      }

      const hasAccess = permissionService.hasPermission(requiredPermissions);
      if (hasAccess) {
        return true;
      } else {
        router.navigate(['/signups']);
        return false;
      }
    })
  );
};

